import r from "clipper-lib";
function s(p) {
  const t = [];
  for (const n of p) {
    const o = new r.IntPoint();
    o.X = n[0], o.Y = n[2], t.push(o);
  }
  return t;
}
export {
  s as polyToPath
};
//# sourceMappingURL=index7.js.map
